import { APIService } from "../../../../../../../../../../network/api/APIService";

export const PayPalData = ({mode = "create", payload, via="paypal"}) => {

    const endpoint = 
        mode === "create" ? "/paypal/orders/" :
         mode === "capture" ? "/paypal/orders/capture/" :
         mode === "refund" ? "/paypal/orders/refund/" :
         mode === "cancel" ? "/paypal/orders/cancel/" :
         mode === "withdraw" ? (via === "paypal" ? "/paypal/withdraw/manual/" : "/licence/withdraw/") : null;

    const config = {
        endpoint: endpoint,
        method: "POST",
        data: payload,
        includeCredentials: false,
        baseUrl: process.env.REACT_APP_APP_PAYMENT_URL,
    };

    return APIService(config);
};